export const BROADCAST_CHANNEL_NAME = 'getuniq-app'

const TAB_ID_STORAGE_KEY = 'broadcast_tab_id'

export const BROADCAST_MESSAGE_TYPES = {
  EMAIL_CONFIRMED: 'EMAIL_CONFIRMED',
}

const isSupported = () => typeof BroadcastChannel !== 'undefined'

export const getTabId = () => {
  let tabId = sessionStorage.getItem(TAB_ID_STORAGE_KEY)

  if (!tabId) {
    tabId =
      typeof crypto?.randomUUID === 'function'
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random()}`
    sessionStorage.setItem(TAB_ID_STORAGE_KEY, tabId)
  }

  return tabId
}

export const postBroadcastMessage = (type, payload = {}) => {
  if (!isSupported()) {
    return
  }

  const channel = new BroadcastChannel(BROADCAST_CHANNEL_NAME)

  channel.postMessage({ type, tabId: getTabId(), ...payload })
  channel.close()
}

export const subscribeToBroadcastMessages = (handler) => {
  if (!isSupported()) {
    return () => {}
  }

  const channel = new BroadcastChannel(BROADCAST_CHANNEL_NAME)
  channel.onmessage = ({ data }) => handler(data)

  return () => {
    channel.onmessage = null
    channel.close()
  }
}
